import createFavoritePersonasRootFolder from '../createFavoritePersonasRootFolder';
import retrieveRootFavoritePersonasFolder from '../retrieveRootFavoritePersonasFolder';
import { logUsage } from 'owa-analytics-actions';
import Folder from 'owa-service/lib/contract/Folder';
import { PROPERTY_TAG_HIDDEN } from '../createSearchFolderForPersona';

// Retrieves the folderId of 'FavoritePersonas', creates the folder if it doesn't exist
// In case the folder was created between retrieveFavoritePersonasFolder() and createFavoritePersonaFolder()
// we return the created folder
export default async function getFavoritePersonasRootFolderId(): Promise<string> {
    try {
        const favoritePersonaFolder = await retrieveRootFavoritePersonasFolder();
        if (favoritePersonaFolder) {
            logIsHiddenProperty(favoritePersonaFolder);
            return favoritePersonaFolder.FolderId.Id;
        }

        return await createFavoritePersonasRootFolder();
    } catch (reason) {
        // Folder exists should not impact user experience
        if (reason === 'ErrorFolderExists') {
            const favoritePersonaFolder = await retrieveRootFavoritePersonasFolder();
            logIsHiddenProperty(favoritePersonaFolder);
            return favoritePersonaFolder.FolderId.Id;
        }
        throw reason;
    }
}

function logIsHiddenProperty(favoritePersonaFolder: Folder): void {
    if (!(favoritePersonaFolder && favoritePersonaFolder.ExtendedProperty)) {
        return;
    }

    const isHiddenProperty = favoritePersonaFolder.ExtendedProperty.filter(
        prop =>
            prop.ExtendedFieldURI &&
            prop.ExtendedFieldURI.PropertyTag &&
            prop.ExtendedFieldURI.PropertyTag.toLocaleLowerCase() === PROPERTY_TAG_HIDDEN
    );
    const isHidden =
        isHiddenProperty && isHiddenProperty.length === 1
            ? isHiddenProperty[0].Value
            : 'Property not found';

    logUsage('RootFavoritePersonaFolderLoaded', { isFolderHidden: isHidden });
}
